export default __webpack_public_path__ + "static/media/0009.9f256326.jpg";